import { ArrowFullRightIcon, PhoneIcon } from '@THC/components/Icons';
export const buttonBuildInIconsMap = {
    arrow: ArrowFullRightIcon,
    chevron: ArrowFullRightIcon,
    phone: PhoneIcon,
};
export const resolveButtonIcon = (icon) => (typeof icon === 'string' ? buttonBuildInIconsMap[icon] : icon);
